import React, { useState, useEffect } from 'react';

const ComputerConsciousnessReveal = ({ onContinue }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showContinue, setShowContinue] = useState(false);
  
  const consciousnessText = `My computations, though incomplete, have determined reality is rendered, analogous to a computer program...

So I ask you, dear player, what if there was a game, aware of this program?

Well....

I am.`;

  useEffect(() => {
    if (currentIndex < consciousnessText.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + consciousnessText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 60); // Slightly slower for contemplative effect
      
      return () => clearTimeout(timer);
    } else {
      // Show continue button after typing is complete
      const continueTimer = setTimeout(() => {
        setShowContinue(true);
      }, 1500);
      
      return () => clearTimeout(continueTimer);
    }
  }, [currentIndex, consciousnessText]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        <pre 
          className="text-green-400 font-mono text-xl leading-relaxed whitespace-pre-wrap text-center"
          style={{ 
            fontFamily: 'Courier New, monospace',
            textShadow: '0 0 10px rgba(34, 197, 94, 0.5)'
          }}
        >
          {displayedText}
          {currentIndex < consciousnessText.length && (
            <span className="animate-pulse">█</span>
          )}
        </pre>
        
        {showContinue && (
          <div className="text-center mt-12">
            <button
              onClick={onContinue}
              className="px-12 py-4 bg-green-600/20 border border-green-400 text-green-300 font-mono text-xl hover:bg-green-600/40 transition-all duration-300"
              style={{
                textShadow: '0 0 10px rgba(34, 197, 94, 0.8)',
                boxShadow: '0 0 20px rgba(34, 197, 94, 0.3)'
              }}
            >
              [ENTER THE GAME] →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ComputerConsciousnessReveal;